import { properFullname } from "../../../../../services/utilities";

export const getPhysicianRecordId = (physician = null) =>
  physician?._id ||
  physician?.physician?._id ||
  physician?.physician ||
  physician?.physicianId?._id ||
  physician?.physicianId ||
  "";

export const getClinicRecordId = (physician = null) =>
  physician?.clinic?._id ||
  physician?.clinicId?._id ||
  physician?.clinicId ||
  "";

export const getPhysicianName = (physician = null) =>
  properFullname(
    physician?.fullName ||
      physician?.user?.fullName ||
      physician?.ghost?.fullName ||
      physician?.ghost ||
      physician?.physician?.fullName ||
      physician?.physician?.user?.fullName ||
      physician?.physicianId?.fullName ||
      physician?.physicianId?.user?.fullName
  ) !== "-"
    ? properFullname(
        physician?.fullName ||
          physician?.user?.fullName ||
          physician?.ghost?.fullName ||
          physician?.ghost ||
          physician?.physician?.fullName ||
          physician?.physician?.user?.fullName ||
          physician?.physicianId?.fullName ||
          physician?.physicianId?.user?.fullName
      )
    : [
        physician?.user?.fullName?.fname ||
          physician?.fullName?.fname ||
          physician?.ghost?.fname ||
          physician?.physician?.user?.fullName?.fname ||
          physician?.physicianId?.user?.fullName?.fname,
        physician?.user?.fullName?.mname ||
          physician?.fullName?.mname ||
          physician?.ghost?.mname ||
          physician?.physician?.user?.fullName?.mname ||
          physician?.physicianId?.user?.fullName?.mname,
        physician?.user?.fullName?.lname ||
          physician?.fullName?.lname ||
          physician?.ghost?.lname ||
          physician?.physician?.user?.fullName?.lname ||
          physician?.physicianId?.user?.fullName?.lname,
        physician?.user?.fullName?.suffix ||
          physician?.fullName?.suffix ||
          physician?.ghost?.suffix ||
          physician?.physician?.user?.fullName?.suffix ||
          physician?.physicianId?.user?.fullName?.suffix,
      ]
        .filter(Boolean)
        .join(" ")
        .trim() || "Unnamed physician";

const hasSecretaryAccess = (clinic = {}, authId = "") =>
  (clinic?.secretaries || []).some(
    (secretary) =>
      String(secretary?._id || secretary) === String(authId || "")
  );

const getCurrentClinicPhysician = (activePlatform = {}) => {
  const clinic = activePlatform?.clinic || {};
  const physician = clinic?.physician || clinic?.physicianId || {};

  if (!getPhysicianRecordId(physician)) return null;

  return {
    ...physician,
    clinic,
    clinicId: clinic?._id || "",
    fullName:
      physician?.fullName ||
      physician?.user?.fullName ||
      physician?.ghost?.fullName ||
      physician?.ghost ||
      clinic?.physician?.fullName ||
      clinic?.physician?.user?.fullName ||
      {},
  };
};

const normalizePhysician = (physician = {}, clinic = null) => ({
  ...physician,
  ...(clinic
    ? {
        clinic,
        clinicId: clinic?._id || "",
      }
    : {}),
  fullName:
    physician?.fullName ||
    physician?.user?.fullName ||
    physician?.ghost?.fullName ||
    physician?.ghost ||
    physician?.physician?.fullName ||
    physician?.physician?.user?.fullName ||
    {},
});

export const getMenuPhysicians = ({
  activePlatform = {},
  clinics = [],
  authId = "",
} = {}) => {
  const branchPhysicians = Array.isArray(activePlatform?.physicians)
    ? activePlatform.physicians.map((physician) => normalizePhysician(physician))
    : Array.isArray(activePlatform?.branch?.physicians)
    ? activePlatform.branch.physicians.map((physician) =>
        normalizePhysician(physician)
      )
    : [];

  const sessionClinics = Array.isArray(activePlatform?.clinics)
    ? activePlatform.clinics
    : [];

  const taggedClinicPhysicians = (
    Array.isArray(clinics) && clinics.length ? clinics : sessionClinics
  )
    .filter((clinic) => hasSecretaryAccess(clinic, authId))
    .map((clinic) => {
      const clinicPhysician = clinic?.physician || clinic?.physicianId || {};

      return normalizePhysician(clinicPhysician, clinic);
    })
    .filter((physician) => getPhysicianRecordId(physician));

  const currentClinicPhysician = getCurrentClinicPhysician(activePlatform);
  const merged = [
    ...branchPhysicians,
    ...(currentClinicPhysician ? [currentClinicPhysician] : []),
    ...taggedClinicPhysicians,
  ];
  const deduped = [];
  const seen = new Set();

  merged.forEach((physician) => {
    const physicianId = getPhysicianRecordId(physician);

    if (!physicianId || seen.has(String(physicianId))) return;

    seen.add(String(physicianId));
    deduped.push(physician);
  });

  return deduped;
};
